import React, { useEffect } from "react";
import SignInForm from "./SignIn";
import SignUpForm from "./SignUp";
import "../styles.css";
import userService from "../services/NavaService";
import Swal from "sweetalert2";

export default function LoginModal({ open, onClose, defaultTab = "signIn" }) {
    const [type, setType] = React.useState(defaultTab);
    const [notice, setNotice] = React.useState("");

    useEffect(() => {
        if (!open) return;
        function onKey(e) {
            if (e.key === "Escape") onClose();
        }
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [open, onClose]);

    useEffect(() => {
        if (open) document.body.classList.add("modal-open");
        else document.body.classList.remove("modal-open");
        return () => document.body.classList.remove("modal-open");
    }, [open]);

    if (!open) return null;

    const cardClass =
        "nava-auth-card " + (type === "signUp" ? "nava-auth-right-active" : "");

    const handleSignupSuccess = (msg) => {
        setNotice(msg || "Sign in with your created email");
        setType("signIn");

        setTimeout(() => setNotice(""), 10000);
    };

    const handleLoginSuccess = async (user) => {
        try {
            localStorage.setItem("user", JSON.stringify(user));
            localStorage.setItem("token", user.accessToken);

            const roleResponse = await userService.getUserRoleByUsrId(user.id);
            const roles = roleResponse.data;

            localStorage.setItem("adminYn", roles[0].adminYn);

            window.dispatchEvent(new Event("nava-login"));

            if (typeof onClose === "function") onClose();

            Swal.fire({
                title: "Signed in",
                text: "You have been signed in successfully.",
                icon: "success",
                confirmButtonText: "OK",
                didOpen: () => {
                    const container = document.querySelector(".swal2-container");
                    const popup = document.querySelector(".swal2-popup");
                    if (container) container.style.zIndex = "20010";
                    if (popup) popup.style.zIndex = "20011";
                }
            });

            setNotice("");
        } catch (err) {
            console.error("Failed loading roles", err);

            if (typeof onClose === "function") onClose();

            Swal.fire({
                title: "Signed in",
                text: "Signed in but failed to load roles.",
                icon: "warning",
                didOpen: () => {
                    const container = document.querySelector(".swal2-container");
                    const popup = document.querySelector(".swal2-popup");
                    if (container) container.style.zIndex = "20010";
                    if (popup) popup.style.zIndex = "20011";
                }
            });

            setNotice("Login succeeded but could not load roles.");
        }
    };

    const handleSwitchTab = (target) => {
        setType(target);
    };

    return (
        <div className="nava-auth-modal" role="dialog" aria-modal="true">
            <div className="nava-auth-backdrop" onClick={onClose} />
            <div className="nava-auth-content" onClick={(e) => e.stopPropagation()}>
                <div className={cardClass}>

                    <div className="nava-auth-form-container nava-auth-signup">
                        <SignUpForm onSuccess={handleSignupSuccess} onSwitch={handleSwitchTab} />
                    </div>

                    <div className="nava-auth-form-container nava-auth-signin">
                        <SignInForm notice={notice} onSuccess={handleLoginSuccess} onSwitch={handleSwitchTab} />
                    </div>

                    <div className="nava-auth-overlay-container">
                        <div className="nava-auth-overlay">
                            <div className="nava-auth-overlay-panel nava-auth-overlay-left">
                                <h1>Welcome Back!</h1>
                                <p>To keep connected with us please login with your personal info</p>
                                <button
                                    className="nava-auth-ghost"
                                    onClick={() => setType("signIn")}
                                >
                                    Sign In
                                </button>
                            </div>

                            <div className="nava-auth-overlay-panel nava-auth-overlay-right">
                                <h1>Hello, Friend!</h1>
                                <p>Enter your personal details and start journey with us</p>
                                <button
                                    className="nava-auth-ghost"
                                    onClick={() => setType("signUp")}
                                >
                                    Sign Up
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}
